import { render, staticRenderFns } from "./JomBantuKits.vue?vue&type=template&id=4ac8e331&"
import script from "./JomBantuKits.vue?vue&type=script&lang=js&"
export * from "./JomBantuKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports